import { render, staticRenderFns } from "./OctIconButton.vue?vue&type=template&id=6b6f738e&scoped=true&"
import script from "./OctIconButton.vue?vue&type=script&lang=js&"
export * from "./OctIconButton.vue?vue&type=script&lang=js&"
import style0 from "./OctIconButton.vue?vue&type=style&index=0&id=6b6f738e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f738e",
  null
  
)

export default component.exports